// Base half-unit of pixels in our capital design system
const baseHalfUnit = 4;
const arrayOfMultipliers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

// variable to store the array of valid spacing values
export const getSpaceArray = arrayOfMultipliers.map((multiplier) => `${multiplier * baseHalfUnit}px`);
